<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M32 2H16C12.68 2 10 4.68 10 8V40C10 43.32 12.68 46 16 46H32C35.32 46 38 43.32 38 40V8C38 4.68 35.32 2 32 2ZM34 36H14V8H34V36ZM28 42H20V40H28V42Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
